import {animate, style, transition, trigger} from '@angular/animations';

export const dropDown = trigger(
  'dropDown',
  [
    transition(
      ':enter', [
        style({transform: 'scale(0.9)', opacity: 0, maxHeight: 0, overflow: 'hidden'}),
        animate('150ms', style({transform: 'scale(1)', opacity: 1, maxHeight: '30vh', overflow: 'hidden'})),
      ],
    ),
    transition(
      ':leave', [
        style({transform: 'scale(1)', opacity: 1, maxHeight: '30vh', overflow: 'hidden'}),
        animate('150ms', style({transform: 'scale(0.9)', opacity: 0, maxHeight: 0, overflow: 'hidden'})),
      ],
    )],
);
